import { motion } from 'framer-motion';
import { ArrowDown, Mail, MapPin } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_renovations-pro-1/artifacts/04suonqk_VIDEO%20%281%29.png';
const HERO_BG = 'https://customer-assets.emergentagent.com/job_renovations-pro-1/artifacts/f9akwcm4_Captura%20de%20pantalla%202026-04-13%20a%20la%28s%29%2009.49.53.png';

export default function HeroSection() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Interior arquitectónico"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#F7F7F5]/90" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-28 pb-20">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Text */}
          <div>
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <span className="inline-block font-manrope text-xs font-bold uppercase tracking-[0.2em] text-r2r-sage mb-6">
                Renovaciones Multifamily
              </span>
            </motion.div>

            <motion.h1
              data-testid="hero-heading"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.35 }}
              className="font-outfit text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-extralight tracking-tighter leading-[0.95] text-r2r-text mb-8"
            >
              Departamentos
              <br />
              <span className="font-extrabold">listos para</span>
              <br />
              <span className="font-extrabold text-r2r-primary">arrendar.</span>
            </motion.h1>

            <motion.p
              data-testid="hero-description"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="font-manrope text-base md:text-lg text-r2r-text-secondary leading-relaxed max-w-xl mb-10"
            >
              Renovamos departamentos de multifamily de forma rápida y eficiente, 
              con un modelo sistematizado de ejecución, revisión y entrega que garantiza un alto estándar, 
              lo que nos permite realizar <span className="font-semibold text-r2r-text">cientos de departamentos mensuales.</span>
              <br />
              <span className="font-semibold text-r2r-text">Optimizando los tiempos y con tarifas sin sorpresas.</span>
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.65 }}
              className="flex flex-col sm:flex-row gap-4"
            >
              <button
                data-testid="hero-cta-contact"
                onClick={() => scrollTo('#contacto')}
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-r2r-primary text-white font-manrope text-sm font-semibold tracking-wide hover:bg-r2r-primary-hover transition-all hover:-translate-y-[1px]"
              >
                <Mail size={16} />
                Contáctanos
              </button>
            </motion.div>

            {/* Quick Contact */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              className="mt-12 flex items-center gap-6 text-r2r-text-secondary"
            >
              <div className="flex items-center gap-2">
                <MapPin size={14} className="text-r2r-sage" />
                <span className="font-manrope text-xs">Av Las Condes 7700</span>
              </div>
              <div className="w-[1px] h-4 bg-r2r-border" />
              <a href="mailto:Contacto@Ready2rent.cl" className="font-manrope text-xs hover:text-r2r-text transition-colors">
                Contacto@Ready2rent.cl
              </a>
            </motion.div>
          </div>

          {/* Right: Logo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="hidden lg:flex items-center justify-center"
          >
            <div className="relative w-full max-w-md">
              <div className="border border-r2r-border p-1">
                <img
                  src={LOGO_URL}
                  alt="Ready2Rent Logo"
                  data-testid="hero-logo"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </motion.div>
        </div>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.2 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
        >
          <button
            data-testid="scroll-indicator"
            onClick={() => scrollTo('#servicios')}
            className="flex flex-col items-center gap-2 text-r2r-sage hover:text-r2r-text transition-colors"
          >
            <span className="font-manrope text-[10px] uppercase tracking-[0.2em]">Descubre más</span>
            <ArrowDown size={16} className="animate-bounce" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
